module.exports = __webpack_public_path__ + "static/media/S4N4-2.3a7b7cc9.svg";